import styled from "@emotion/styled";
import { AnimatePresence, motion } from "motion/react";
import { type ReactNode } from "react";

import { PROPERTY_PANEL_WIDTH, SIDEBAR_COLLAPSED_WIDTH, VIEW_BAR_HEIGHT } from "../utilities/constants";
import { useApplicationControlBars } from "./AppContext";

const Container = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  min-height: ${VIEW_BAR_HEIGHT}px;
  max-height: ${VIEW_BAR_HEIGHT}px;
  width: 100%;

  background-color: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.generalTextIcon};

  overflow: hidden;
`;

const Sidebar = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 ${SIDEBAR_COLLAPSED_WIDTH}px;

  height: 100%;

  border-inline-end: 1px solid ${({ theme }) => theme.surfaceBack_1};
`;

const Canvas = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 calc(100% - ${PROPERTY_PANEL_WIDTH + SIDEBAR_COLLAPSED_WIDTH}px);

  height: 100%;
  width: 100%;
`;

const Properties = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 ${PROPERTY_PANEL_WIDTH}px;

  height: 100%;

  border-inline-start: 1px solid ${({ theme }) => theme.surfaceBack_1};
`;

const TransitionContainer = styled(motion.div)`
  position: absolute;

  height: 100%;
  width: 100%;
`;

type Props = {
  persistence?: ReactNode;
  variant?: ReactNode;
};

export const ViewBar = ({ persistence, variant }: Props) => {
  const { viewBar } = useApplicationControlBars();

  return (
    <Container>
      <Sidebar>{persistence}</Sidebar>

      <Canvas>
        <AnimatePresence mode="wait">
          <TransitionContainer
            key={viewBar?.id}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {viewBar?.component}
          </TransitionContainer>
        </AnimatePresence>
      </Canvas>

      <Properties>{variant}</Properties>
    </Container>
  );
};
